import { type RouteRecordRaw } from 'vue-router'

export const YurplanTicketsRouter: RouteRecordRaw[] = [
  {
    path: '/yurplan-tickets',
    component: async () => import('./YurplanTickets.vue'),
  },
]
